import React from 'react';
import { Mail, Phone } from 'lucide-react';
import '../styles/finance-redesign.css';

export default function ContactBar() {
  return (
    <div className='gpm-topbar gpm-contact-redesign'>
      <div className='gpm-shell gpm-topbar-inner'>
        <div>
          <a href='tel:02081784340'>
            <Phone size={12} />
            020 8178 4340
          </a>
          <a className='gpm-email' href='mailto:info@globalpayrollmigration.com'>
            <Mail size={13} />
            <span className='gpm-email-full'>info@globalpayrollmigration.com</span>
            <span className='gpm-email-short'>Email</span>
          </a>
        </div>
      </div>
    </div>
  );
}
